export const CROP_PADDING = 20;
export const THUMB_CORNER_SIZE = 24;
export const THUMB_SIDE_SIZE = 34;
export const THUMB_STROKE_WIDTH = 3;
export const THUMB_OFFSET = THUMB_STROKE_WIDTH / 2;

export const GUIDE_STROKE_WIDTH = 1;
export const GUIDE_THIRD = 100 / 3;
export const MIN_CROP_SIZE = 1;
export const MAX_INTERACTION_SIZE = 24;
export const MIN_INTERACTION_SIZE = 6;
